/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
import MomentTz from 'moment-timezone';
import moment from 'moment';
import { Category } from './filters';
import { VAULT_MEDIA_TYPE } from '../../constants/vault';

function convertGameDate(date) {
  if (date && new Date(date).toString() !== 'Invalid Date') {
    const formattedDate = MomentTz.utc(date).format('ll');
    return formattedDate;
  }
  return null;
}

function convertDate(date) {
  if (date && new Date(date).toString() !== 'Invalid Date') {
    const formattedDate = moment(date).format('ll');
    return formattedDate;
  }
  return null;
}

function fixGameDate(metaTags, rawAssetDetails) {
  if (rawAssetDetails?.gameDate !== undefined) {
    const mainCatIndex = metaTags.findIndex((cat) => cat.category === 'game');
    if (mainCatIndex > 0) {
      const spIndex = metaTags[mainCatIndex].tags.findIndex(
        (tag) => tag.tagName === 'gameDate',
      );
      if (rawAssetDetails.type === VAULT_MEDIA_TYPE.clip) { // Display clip game date in local time to avoid incorrect dates for late night ET events.
        metaTags[mainCatIndex].tags[spIndex].value = convertDate(rawAssetDetails.gameDate);
      } else {
        metaTags[mainCatIndex].tags[spIndex].value = convertGameDate(rawAssetDetails.gameDate);
      }
    }
  }
}

function fixCaptureDate(metaTags, rawAssetDetails) {
  if (rawAssetDetails?.captureDate !== undefined) {
    const mainCatIndex = metaTags.findIndex((cat) => cat.category === 'eventInfo');
    if (mainCatIndex >= 0) {
      const spIndex = metaTags[mainCatIndex].tags.findIndex(
        (tag) => tag.tagName === 'captureDate',
      );
      if (rawAssetDetails.type === VAULT_MEDIA_TYPE.clip) { // Display clip game date in local time to avoid incorrect dates for late night ET events.
        metaTags[mainCatIndex].tags[spIndex].value = convertDate(rawAssetDetails.captureDate);
      } else {
        metaTags[mainCatIndex].tags[spIndex].value = convertGameDate(rawAssetDetails.captureDate);
      }
    }
  }
}

// VV-226: the comment's attribution reads as a single "Last Updated" line - "<date time> by
// <name>" - rather than separate date and author rows, so exchangeCommentBy is hidden
// (isEditable 0) and folded in here. Composed at this level because AssetField only receives
// its own field's value, not the rest of the asset. Only the comment itself is editable; this
// line is derived and read-only.
function fixExchangeCommentAt(metaTags, rawAssetDetails) {
  const commentedAt = rawAssetDetails?.exchangeCommentAt;
  if (!commentedAt || new Date(commentedAt).toString() === 'Invalid Date') return;
  const catIndex = metaTags.findIndex((cat) => cat.category === 'main');
  if (catIndex < 0) return;
  const tagIndex = metaTags[catIndex].tags.findIndex((tag) => tag.tagName === 'exchangeCommentAt');
  if (tagIndex < 0) return;
  const when = MomentTz.tz(commentedAt, MomentTz.tz.guess()).format('L LT');
  const by = rawAssetDetails.exchangeCommentBy;
  metaTags[catIndex].tags[tagIndex].value = by ? `${when} by ${by}` : when;
}

function replaceIdWithValue(metaTags, rawAssetDetails, securityProfileIdValueMapping) {
  // replace security profile ids with value
  if (rawAssetDetails?.securityProfiles !== undefined) {
    const securityProfileIdList = rawAssetDetails.securityProfiles;
    if (securityProfileIdList) {
      const isValidSecurityProfile = Array.isArray(securityProfileIdList);
      // VV-315: only the profiles this user can see are named. The API leaves the Film Room
      // group out of the profile list for anyone but a super admin, so its id has no name
      // here; it is left out rather than shown as an empty entry, and AssetDetails keeps it
      // on the asset when the field is saved.
      const securityProfileValueList = isValidSecurityProfile
        ? securityProfileIdList
          .map((spId) => securityProfileIdValueMapping.find((sp) => sp._id === spId)?.name)
          .filter((name) => name !== undefined)
        : [];
      const mainCatIndex = metaTags.findIndex((cat) => cat.category === 'main');
      const spIndex = metaTags[mainCatIndex].tags.findIndex(
        (tag) => tag.tagName === 'securityProfiles',
      );
      metaTags[mainCatIndex].tags[spIndex].value = securityProfileValueList;
    }
  }
  // replace owner ids with value, and convert owner list to string
  if (rawAssetDetails?.owner !== undefined && typeof rawAssetDetails.owner === 'object') {
    const ownerList = rawAssetDetails.owner;
    if (ownerList) {
      const ownerValueList = ownerList.map((spId) => {
        const sp = securityProfileIdValueMapping.find((sp) => sp._id === spId);
        if (sp) {
          return sp.name;
        }
      });
      const mainCatIndex = metaTags.findIndex((cat) => cat.category === 'main');
      const spIndex = metaTags[mainCatIndex].tags.findIndex((tag) => tag.tagName === 'owner');
      metaTags[mainCatIndex].tags[spIndex].value = ownerValueList.length ? ownerValueList[0] : '';
    }
  }
}

export function generateRenderableAssetDetails(
  metaTagsByCategory,
  rawAssetDetails,
  securityProfileIdValueMapping,
) {
  const metaTags = JSON.parse(JSON.stringify(metaTagsByCategory));
  Object.keys(rawAssetDetails).forEach((tag) => {
    metaTags.forEach((category) => {
      category.tags.forEach((metaTag) => {
        if (
          metaTag.tagName === tag
          && rawAssetDetails[tag] !== null // no initial value
          && rawAssetDetails[tag] !== '' // empty value
        ) {
          metaTag.value = rawAssetDetails[tag];
        }
      });
    });
  });
  // replace security profiles id with value
  replaceIdWithValue(metaTags, rawAssetDetails, securityProfileIdValueMapping);
  fixGameDate(metaTags, rawAssetDetails);
  fixCaptureDate(metaTags, rawAssetDetails);
  fixExchangeCommentAt(metaTags, rawAssetDetails);
  // filter out tags has no value attached
  metaTags.forEach((category) => {
    const filteredTag = category.tags.filter(
      (metaTag) => typeof metaTag.value !== 'undefined'
        && !(metaTag.tagName === 'securityProfiles' && !metaTag.value.length) // empty security profiles list
        && !(metaTag.tagName === 'owner' && !metaTag.value), // empty owner list
    );
    category.tags = [...filteredTag];
  });
  // filter out empty category
  const renderableAssetDetails = metaTags.filter((category) => category.tags.length > 0);
  // array of objects
  return renderableAssetDetails;
}

export function generateEditableAssetDetails(
  metaTagsByCategory,
  rawAssetDetails,
  securityProfileIdValueMapping,
) {
  const metaTags = JSON.parse(JSON.stringify(metaTagsByCategory)).filter(({ category }) => {
    // apply category filters based on asset details
    if (Object.keys(Category).includes(category)) {
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(Category[category])) {
        if (Array.isArray(value) ? !value.includes(rawAssetDetails[key]) : rawAssetDetails[key] !== value) {
          return false;
        }
      }
    }
    return true;
  });
  Object.keys(rawAssetDetails).forEach((tag) => {
    metaTags.forEach(({ tags }) => {
      tags.forEach((metaTag) => {
        if (metaTag.tagName === tag && rawAssetDetails[tag] !== null) {
          metaTag.value = rawAssetDetails[tag];
        }
      });
    });
  });
  replaceIdWithValue(metaTags, rawAssetDetails, securityProfileIdValueMapping);
  fixGameDate(metaTags, rawAssetDetails);
  fixCaptureDate(metaTags, rawAssetDetails);
  // filter out tags has no value attached
  metaTags.forEach((category) => {
    category.tags.forEach((metaTag) => {
      typeof metaTag.value === 'undefined' && (metaTag.value = null);
    });
  });
  // array of objects
  return metaTags;
}

export function filterAssetFieldsWithValue(editableAssetDetails) {
  const assetDetails = JSON.parse(JSON.stringify(editableAssetDetails));
  assetDetails.forEach((category) => {
    const filteredTag = category.tags.filter(
      (metaTag) => metaTag.value !== ''
        && metaTag.value !== null
        && !(metaTag.tagName === 'securityProfiles' && !metaTag.value.length)
        && !(metaTag.tagName === 'owner' && !metaTag.value.length),
    );
    category.tags = [...filteredTag];
  });
  const renderableAssetDetails = assetDetails.filter((category) => category.tags.length > 0);
  return renderableAssetDetails;
}
